var lastScroll = 0;
window.addEventListener('scroll', (e)=>{
  let scrollCount = window.pageYOffset;
  let collNav;
  if(document.querySelector('.snippet-collection-navigation')){
    collNav = document.querySelector('.snippet-collection-navigation').offsetTop + document.querySelector('.snippet-collection-navigation ul').scrollHeight
  }
  setTimeout(function(){
    if(scrollCount > lastScroll){
      document.querySelector('body').classList.remove('scroll-up');
      document.querySelector('body').classList.add('scroll-down');
      let height;
      if(document.querySelector('.section-announcement-bar')){
        height = document.querySelector('header').offsetHeight + document.querySelector('.section-announcement-bar').clientHeight
      }else{
        height = document.querySelector('header').offsetHeight
      }
      if(scrollCount <= (height)){
        document.querySelector('header').classList.remove('normal-header');
      }else{
        document.querySelector('header').classList.add('normal-header');
      }
      let scrolledHeight;
      if(document.querySelector('.section-announcement-bar')){
        scrolledHeight = document.querySelector('header').offsetHeight + document.querySelector('.section-announcement-bar').clientHeight + 100
      }else{
        scrolledHeight = document.querySelector('header').offsetHeight + 100
      }
      if(scrollCount >= scrolledHeight) document.querySelector('header').classList.add('animate-header');
      if(collNav && scrollCount >= collNav){
        document.querySelector('body').classList.add('filter-sticky');
        if(window.outerWidth < 992){
          document.querySelector('header').style.top = '-'+document.querySelector('header').clientHeight+'px';
          document.querySelector('.filter-sticky .sticky-collection-navigation').style.transform = 'translateY(0px)';
        }
      }
    }else if(scrollCount < lastScroll){
      document.querySelector('body').classList.remove('scroll-down');
      if(collNav){
        document.querySelector('body').classList.remove('filter-sticky');
        if(window.outerWidth < 992){
          if(!document.querySelector('body').classList.contains('filter-sticky') && scrollCount >= collNav){
            document.querySelector('header').style.top = '0px';
            document.querySelector('.sticky-collection-navigation').style.transform = 'translateY('+document.querySelector('header').clientHeight+'px)';
          }else{
           document.querySelector('.sticky-collection-navigation').style.transform = 'translateY(-100%)'; 
          }
        }
      }
      document.querySelector('body').classList.add('scroll-up');
      if(scrollCount <= document.querySelector('header').offsetHeight){
        document.querySelector('header').classList.remove('normal-header');
      }else{
        document.querySelector('header').classList.add('normal-header');
      }
      if(scrollCount <= (document.querySelector('header').offsetHeight + 100)) document.querySelector('header').classList.remove('animate-header');
    }
    lastScroll = scrollCount;
  }, 0);
});
document.addEventListener("DOMContentLoaded", (event) => {
  // if(document.querySelector('.list-menu')){
  //   document.querySelectorAll('.list-menu > li.mega-list > a').forEach(function(navList){
  //     navList.addEventListener('click',function(e){
  //       e.preventDefault();
  //       let right = window.innerWidth - document.body.clientWidth;
  //       if(document.querySelector('body').classList.contains('scroll-up')){
  //         document.querySelector('body').style.paddingRight = right+'px';
  //         document.querySelector('main').style.width = 'calc(100% + '+right+'px)';
  //         document.getElementById('shopify-section-announcement-bar').style.width = 'calc(100% + '+right+'px)';
  //         document.getElementById('shopify-section-header').style.width = 'calc(100% + '+right+'px)';
  //         document.getElementById('shopify-section-footer').style.width = 'calc(100% + '+right+'px)';
  //       }else{
  //         document.querySelector('body').style.paddingRight = '';
  //         document.querySelector('main').style.width = '';
  //         document.getElementById('shopify-section-announcement-bar').style.width = '';
  //         document.getElementById('shopify-section-header').style.width = '';
  //         document.getElementById('shopify-section-footer').style.width = '';
  //       }
  //       let menusOpen = document.querySelectorAll(".list-menu > li.active");
  //       menusOpen.forEach((menuOpen) => {
  //         menuOpen.classList.remove("active");
  //       });
  //       navList.closest('li').classList.add('active');
  //       document.querySelector('body').classList.remove('open-drawer','open-account-popup','open-search');
  //       document.querySelector('body').classList.add('open-nav');
  //     });
  //   });
  // }
  if(document.querySelector('.menu-burdger button')){
    document.querySelector('.menu-burdger button').addEventListener('click',function(e){
      document.querySelector('body').classList.toggle('open-menu');
      document.querySelector('body').classList.remove('open-drawer','open-search','open-sort','open-filter','open-account-popup');
      let annouce = document.querySelector('.section-announcement-bar').scrollHeight;
      let header = document.querySelector('.section-header').scrollHeight;
      setTimeout(() => {
        if(document.querySelector('.snippet-menu-drawer').scrollHeight <= document.querySelector('.snippet-menu-drawer').clientHeight){
          document.querySelector('header').classList.remove('menu-has-scroll');
        }
      }, 200);
    });
  }
  if(document.querySelector('.nav-arrow')){
    document.querySelectorAll('.nav-arrow').forEach(function(navArrow){
      navArrow.addEventListener('click',function(e){
        var li = navArrow.closest('li');
        var panelId = li.dataset.panel;
        if(panelId){
          var panel = document.querySelector('.navmobile-dropdown[data-panel="' + panelId + '"]');
          if(panel) panel.classList.add('active');
        } else {
          li.classList.toggle('active');
          if(document.querySelector('.snippet-menu-drawer').scrollHeight <= document.querySelector('.snippet-menu-drawer').clientHeight){
            document.querySelector('header').classList.remove('menu-has-scroll');
          }
        }
      });
    });
  }
  document.querySelectorAll('.navpanel-back').forEach(function(btn){
    btn.addEventListener('click',function(){
      btn.closest('.navmobile-dropdown').classList.remove('active');
    });
  });
  document.querySelectorAll('.navpanel-close').forEach(function(btn){
    btn.addEventListener('click',function(){
      document.querySelectorAll('.navmobile-dropdown.active').forEach(function(p){ p.classList.remove('active'); });
      document.querySelector('body').classList.remove('open-menu');
    });
  });
  document.querySelector('.snippet-menu-drawer').addEventListener('scroll', (e)=>{
    if(document.querySelector('.snippet-menu-drawer').scrollTop > 0){
      if(document.querySelector('.snippet-menu-drawer').scrollHeight > document.querySelector('.snippet-menu-drawer').clientHeight){
        document.querySelector('header').classList.add('menu-has-scroll');
      }else{
        document.querySelector('header').classList.remove('menu-has-scroll');
      }
    }else{
      document.querySelector('header').classList.remove('menu-has-scroll');
    }
  });
});
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }
  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }
  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
    this.elements.button.focus();
  }
  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }
  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);

if(document.querySelectorAll('.log-reg-top .reg-text') != null){
   document.querySelectorAll('.log-reg-top .reg-text').forEach(function(element) {
    element.addEventListener('click', function() {
      document.querySelector('.login-popup').classList.add('d-none');
      document.querySelector('.reg-popup').classList.remove('d-none');
    });
  }); 
}
if(document.querySelectorAll('.log-reg-top .login-text') != null){
  document.querySelectorAll('.log-reg-top .login-text').forEach(function(element) {
    element.addEventListener('click', function() {
      document.querySelector('.login-popup').classList.remove('d-none');
      document.querySelector('.reg-popup').classList.add('d-none');
    });
  });
}
if(document.querySelectorAll('.header-icons li.userlist.click') != null){
  document.querySelectorAll('.header-icons li.userlist.click').forEach(function(element) {
    element.addEventListener('click', function() {
      let right = window.innerWidth - document.body.clientWidth
      if(document.querySelector('body').classList.contains('scroll-up')){
        document.querySelector('body').style.paddingRight = right+'px';
        document.querySelector('main').style.width = 'calc(100% + '+right+'px)';
        document.getElementById('shopify-section-announcement-bar').style.width = 'calc(100% + '+right+'px)';
        document.getElementById('shopify-section-header').style.width = 'calc(100% + '+right+'px)';
        document.getElementById('shopify-section-footer').style.width = 'calc(100% + '+right+'px)';
      }else{
        document.querySelector('body').style.paddingRight = '';
        document.querySelector('main').style.width = '';
        document.getElementById('shopify-section-announcement-bar').style.width = '';
        document.getElementById('shopify-section-header').style.width = '';
        document.getElementById('shopify-section-footer').style.width = '';
      }
      document.querySelector('body').classList.toggle('open-account-popup');
      // document.querySelector('.snippet-menu-drawer').style.height = '';
      if(document.querySelectorAll(".list-menu > li.active")) document.querySelectorAll(".list-menu > li.active").forEach((menuOpen) => {
        menuOpen.classList.remove("active");
      });
      document.querySelector('body').classList.remove('open-nav','open-search','open-drawer','open-menu');
    });
  });
}
if (document.querySelector(".cart-sidebar") != null) {
 window.addEventListener('scroll', function() {
    var scroll =  window.scrollY;
    if(scroll > 100){
      document.querySelector(".cart-sidebar").classList.add('active');
    }else{
      document.querySelector(".cart-sidebar").classList.remove('active');
    }
  }); 
}
if(document.querySelector('.list-menu')){
  document.querySelectorAll('.list-menu > li.mega-list').forEach(function(navList){
    navList.addEventListener('mouseover', function(){
      document.querySelector('body').classList.remove('open-nav','open-search','open-drawer','open-menu','open-account-popup');
    });
  });
}